import script from "./Document.vue?vue&type=script&setup=true&lang=js"
export * from "./Document.vue?vue&type=script&setup=true&lang=js"

import "./Document.vue?vue&type=style&index=0&id=54b79ca2&lang=scss&scoped=true"

import exportComponent from "C:\\AQRepo\\customermanagedinspection_fe-brands-kra-norden\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54b79ca2"]])

export default __exports__